
import React, { useState } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Typography, Select } from '@material-ui/core';
import MoreIcon from '@material-ui/icons/ExpandMore';
import SettingsIcon from '@material-ui/icons/Settings';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';


const style = {
    formControl: {
        margin: 0,
        minWidth: 120,
        flexGrow: 1
    },
    selectEmpty: {
        marginTop: 0,
    },
};

// <SelectWithAdd label="" collection={[]} selection="" handleChangeSelection={(param)=>{}} handleAdd={()=>{} ></SelectWithAdd>

const SelectWithGroup = (props) => {

    // groupdata = {
    //     groups:{},
    //     group:"",
    //     selection:""
    // }
    const [groupData, setGroupData] = useState(props.data);

    const groups = Object.keys(props.data.groups);
    const selections = Object.keys(props.data.groups[props.data.group].collection) || []

    console.log('SelectWithMore:', props.selection, props.label)

    const handleChangeSelection = () => {
    
    }

    const handleChangeGroup = () => {

    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <FormControl variant="outlined" style={{...style.formControl, width:'30%'}}>
            <InputLabel id="demo-simple-select-outlined-label">{props.groupLabel}</InputLabel>
            <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                // value={props.selection}
                // onChange={props.handleChangeSelection}
                label={props.groupLabel}
                style={{width:'100%', display:'inline-block'}}
                >
                {groups.map((key, index) => (
                    <MenuItem key={index} value={key}>
                        <Typography>
                            {key}
                        </Typography>
                    </MenuItem>
                    ))}
            </Select>
            {/* <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={props.selection}
                onChange={props.handleChangeSelection}
                label={props.label}
                style={{width:'75%'}}
                >
                {props.collection.map((key, index) => (
                    <MenuItem key={index} value={key}>
                        <Typography>
                            {key}
                        </Typography>
                    </MenuItem>
                    ))}
            </Select> */}
        </FormControl>
        <FormControl variant="outlined" style={{...style.formControl, width:'70%'}}>
            <InputLabel id="demo-simple-select-outlined-label">{props.label}</InputLabel>
            <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                // value={props.selection}
                // onChange={props.handleChangeSelection}
                label={props.label}
                style={{width:'100%', display:'inline-block'}}
                >
                {selections.map((key, index) => (
                    <MenuItem key={index} value={key}>
                        <Typography>
                            {key}
                        </Typography>
                    </MenuItem>
                    ))}
            </Select>
            {/* <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={props.selection}
                onChange={props.handleChangeSelection}
                label={props.label}
                style={{width:'75%'}}
                >
                {props.collection.map((key, index) => (
                    <MenuItem key={index} value={key}>
                        <Typography>
                            {key}
                        </Typography>
                    </MenuItem>
                    ))}
            </Select> */}
        </FormControl>
        {/* { (props.handleMore)?
            <Button variant="outlined" color="primary" onClick={props.handleMore} style={{padding:"15px 0px"}}>
                <MoreIcon style={{margin:"2px"}}></MoreIcon>
            </Button>:null
        }
        { (props.handleSettings)?
            <Button variant="outlined" color="primary" onClick={props.handleSettings} style={{padding:"15px 0px"}}>
                <SettingsIcon style={{margin:"2px"}}></SettingsIcon>
            </Button>:null
        }
        { (props.handleAdd)?
            <Button variant="outlined" color="primary" onClick={props.handleAdd} style={{padding:"15px 0px"}}>
                <AddIcon style={{margin:"2px"}}></AddIcon>
            </Button>:null
        }
         { (props.handleEdit)?
            <Button variant="outlined" color="primary" onClick={props.handleAdd} style={{padding:"15px 0px"}}>
                <EditIcon style={{margin:"2px"}}></EditIcon>
            </Button>:null
        } */}
        </div>
    )
}

export default SelectWithGroup;